/* @flow strict */

import * as React from 'react';
import './registrationInfoForm.scss';

type PropsType = {
  onChange: () => void,
  formSubmited: boolean
};

const RegistrationForm = (props: PropsType): React.Element<'div'> => {
  const { onChange, formSubmited } = props;

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');

  const handleFirstName = (e: {}) => {
    e.persist();
    setFirstName(e.target.value);
    onChange(e);
  };
  const handleLastName = (e: {}) => {
    e.persist();
    setLastName(e.target.value);
    onChange(e);
  };
  const handleEmail = (e: {}) => {
    e.persist();
    setEmail(e.target.value);
    onChange(e);
  };
  const handlePhone = (e: {}) => {
    e.persist();
    setPhone(e.target.value);
    onChange(e);
  };

  return (
    <>
      <div className='sparxo-checkout-registration-info-form_inputPair'>
        <div className='sparxo-checkout-registration-info-form_inputContainer'>
          <div className='sparxo-checkout-registration-info-form_inputCaption'>First name</div>
          <input
            className={`sparxo-checkout-registration-info-form_input ${formSubmited && !firstName && 'sparxo-checkout-registration-info-form_inputError'}`}
            name='firstName'
            type='text'
            value={firstName}
            onChange={(e: {}): void => handleFirstName(e)}
          />
          {
            formSubmited && !firstName &&
            <div className='sparxo-checkout-registration-info-form_inputErrorCaption'>Required</div>
          }
        </div>
        <div className='sparxo-checkout-registration-info-form_inputContainer'>
          <div className='sparxo-checkout-registration-info-form_inputCaption'>Email</div>
          <input
            className={`sparxo-checkout-registration-info-form_input ${formSubmited && !email && 'sparxo-checkout-registration-info-form_inputError'}`}
            name='email'
            type='text'
            value={email}
            onChange={(e: {}): void => handleEmail(e)}
          />
          {
            formSubmited && !email &&
            <div className='sparxo-checkout-registration-info-form_inputErrorCaption'>Required</div>
          }
        </div>
      </div>
      <div className='sparxo-checkout-registration-info-form_inputPair'>
        <div className='sparxo-checkout-registration-info-form_inputContainer'>
          <div className='sparxo-checkout-registration-info-form_inputCaption'>Last name</div>
          <input
            className={`sparxo-checkout-registration-info-form_input ${formSubmited && !lastName && 'sparxo-checkout-registration-info-form_inputError'}`}
            name='lastName'
            type='text'
            value={lastName}
            onChange={(e: {}): void => handleLastName(e)}
          />
          {
            formSubmited && !lastName &&
            <div className='sparxo-checkout-registration-info-form_inputErrorCaption'>Required</div>
          }
        </div>
        <div className='sparxo-checkout-registration-info-form_inputContainer'>
          <div className='sparxo-checkout-registration-info-form_inputCaption'>Phone number</div>
          <input
            className={`sparxo-checkout-registration-info-form_input ${formSubmited && !phone && 'sparxo-checkout-registration-info-form_inputError'}`}
            name='phone'
            type='text'
            value={phone}
            onChange={(e: {}): void => handlePhone(e)}
          />
          {
            formSubmited && !phone &&
            <div className='sparxo-checkout-registration-info-form_inputErrorCaption'>Required</div>
          }
        </div>
      </div>
    </>
  );
};

export default RegistrationForm;